import { useNavigate } from 'react-router-dom'

import { angleLeft } from '../../../assets/icons'

export default function LinkBackButton({
    buttonText,
    buttonUrl,
    state
}: {
    buttonText: string
    buttonUrl: string
    state?: unknown
}) {
    const navigate = useNavigate()

    const navigateToUrl = () => {
        // KioskReplaceNavigator forces replace globally; pass it explicitly
        // so in-app back never depends on push history.
        navigate(buttonUrl, { state, replace: true })
    }

    return (
        <button className="link-back-button" onClick={navigateToUrl}>
            <img className="link-back-ico" alt={buttonText} src={angleLeft} />
            <span className="link-back-text">{buttonText}</span>
        </button>
    )
}
